<template>
  <div class="flex-col flex gap-4 rounded-[20px] bg-white pb-8 max-w-[700px]">
    <div class="text-center rounded-t-[20px]" :class="[color === 'blue' ? 'bg-[#2699C6]' : 'bg-brand-orange']">
      <p class="font-bold text-white text-[24px] self-stretch py-[10px] px-[20px]" style="line-height: 24px">{{this.programArticle.start}}–{{this.programArticle.end}}</p>
    </div>
    <div class="flex flex-row gap-4 mx-[20px]">
      <img class="lg:w-32 lg:h-32 md:w-24 md:h-24 h-[90px] w-[90px] md:min-w-24 md:min-h-24 rounded-full object-cover" style="aspect-ratio: 1/1" :src="programArticle.speaker.photo_url" :alt="programArticle.speaker.name">
      <div class="flex flex-col py-2 gap-1">
        <p class="justify-start lg:text-lg text-[16px] font-semibold font-['Inter'] uppercase leading-normal tracking-wide" :class="[color === 'blue' ? 'text-[#2699C6]' : 'text-brand-orange']">{{programArticle.speaker.name}}</p>
<!--        <img class="lg:w-24 lg:h-5 w-[70px] h-[15px]" :src="programArticle.speaker.company" alt="test">-->
        <p class="justify-start text-gray-900 lg:text-[24px] text-[18px] font-semibold">{{ truncatedTitle }}</p>
      </div>
    </div>
    <div class="mx-[16px] md:block hidden">
      <p class="text-[#6B7280] text-[16px] font-medium overflow-hidden text-ellipsis h-24" style="line-height: 24px">{{truncatedDescription}} <button @click.prevent="action" v-if="hasTextOverflow" class="text-[16px] underline cursor-pointer" :class="[color === 'blue' ? 'text-[#2699C6]' : 'text-brand-orange']"> Více informací</button></p>
    </div>
    <div v-if="userLoggedIn && programVotingOpened" class="ml-4">
      <RadioButton
        @clicked="removeTimeSlot"
        :name="'timeslot-' + programArticle.timeslot.index"
        :color="color"
        :radioValue="programArticle.hall"
        :radioId="programArticle.id.toString()"
        label="Tohle chci vidět"
        v-model="selected"
      />
    </div>
  </div>
</template>

<script>
import RadioButton from "../../Atomic/Radio.vue";
export default {
  emits: [
    "clicked",
    "update:timeslotSelections",
  ],
  name: 'ProgramCardDva',
  components: {RadioButton},
  props: {
    programArticle: {
      type: Object,
      required: true
    },
    timeslotSelections: {
      type: Object,
      default: undefined,
    },
    programVotingOpened: {
      type: Boolean,
      default: false
    },
    userLoggedIn: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: 'orange'
    }
  },
  methods: {
    async removeTimeSlot() {
      if (this.selected === this.programArticle.hall) {
        const res = await axios.delete(
          `/api/timeslot/${this.programArticle.timeslot.index}`
        );
        this.$emit("update:timeslotSelections", res.data);
      }
    },
    action() {
      this.$emit("clicked", {
        ...this.programArticle,
        time: this.talkTime(),
      });
    },
    talkTime() {
      if (this.programArticle.start === undefined) {
        return "Čas přednášky";
      }

      return this.programArticle.start + "–" + this.programArticle.end;
    },
  },
  computed: {
    truncatedDescription() {
      let text = this.programArticle.annotation;

      if (text.length && text.length > 185) {
        text = text.substring(0, 185);
        text += "...";
      }

      return text;
    },
    truncatedTitle() {
      let text = this.programArticle.title;

      if (text.length && text.length > 55) {
        text = text.substring(0, 55);
        text += "...";
      }

      return text;
    },
    hasTextOverflow() {
      return this.programArticle.annotation.length > 185;
    },
    selected: {
      get() {
        if (!this.programVotingOpened) return "";

        if (
          this.timeslotSelections === undefined ||
          this.timeslotSelections.timeslots === undefined
        ) {
          return "";
        }

        if (
          this.timeslotSelections.timeslots[
            this.programArticle.timeslot.index
            ] === null
        ) {
          return "";
        }

        return this.timeslotSelections.timeslots[
          this.programArticle.timeslot.index
          ] === 0
          ? "heureka"
          : "purple";
      },

      async set() {
        const hallAsString = this.programArticle.hall === "heureka" ? 0 : 1;

        const res = await axios.post(
          `/api/timeslot/${this.programArticle.timeslot.index}/${hallAsString}`
        );

        this.$emit("update:timeslotSelections", res.data);
      },
    },
  },
}
</script>

<style scoped>
/* Optional: Tailwind line clamp plugin for limiting description lines */
.line-clamp-5 {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
